// Barel export to easily import everything from '/user' path

export { UserModule } from './user.module';
export { UserRoutingModule } from './user-routing.module';
export { UserService } from './user.service';
export { UserLoginComponent } from './user-login/user-login.component';
export { UserEditComponent } from './user-edit/user-edit.component';
export { UserViewComponent } from './user-view/user-view.component';



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/user/index.ts